import { Component } from '@angular/core';
import { PaginationComponent, PaginationItem } from '@spartacus/storefront';

@Component({
  selector: 'kb-pagination',
  templateUrl: './kbs-site-pagination.component.html',
  styleUrl: './kbs-site-pagination.component.scss',
  standalone: false
})
export class KbsSitePaginationComponent extends PaginationComponent {
  isType(item: PaginationItem): boolean {
    return item.type != 'page';
  }
}
